export const dictPermissionsModuleReportes: { [key: string]: any } =
  Object.freeze({
    reportes_mov: 904,
    reportes_dev: 905,
  });

export const listPermissionsModuleReportes = Object.keys(
  dictPermissionsModuleReportes
).map((key: string) => dictPermissionsModuleReportes[key]);
